module.exports = __webpack_public_path__ + "components/weather-icon/static/nightthunderstorm-6e92a9b8b708dc320c649841427505f1.png";